import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile(breakpoint: number | string = MOBILE_BREAKPOINT) {
	const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

	React.useEffect(() => {
		let mediaQuery: string

		if (typeof breakpoint === "string") {
			// 如果传入的是媒体查询字符串，直接使用
			mediaQuery = breakpoint
		} else {
			// 如果传入的是数字，使用原有逻辑
			mediaQuery = `(max-width: ${breakpoint - 1}px)`
		}

		const mql = window.matchMedia(mediaQuery)
		const onChange = () => {
			if (typeof breakpoint === "string") {
				setIsMobile(mql.matches)
			} else {
				setIsMobile(window.innerWidth < breakpoint)
			}
		}

		mql.addEventListener("change", onChange)

		// 初始设置
		if (typeof breakpoint === "string") {
			setIsMobile(mql.matches)
		} else {
			setIsMobile(window.innerWidth < breakpoint)
		}

		return () => mql.removeEventListener("change", onChange)
	}, [breakpoint])

	return !!isMobile
}
